import * as React from 'react';
import { useState, useRef, useEffect } from 'react';
import moment from "moment";
import { ajax } from "jquery";
import { useHistory } from 'react-router-dom';

import Button from '../../components/forms/button';
import ContentTitle from '../../components/common/container/title';
import InlineInput from '../../components/forms/inlineinput';
import InlineData from '../../components/forms/inlinedata';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import IRC0111Table from "./irc0111-table";
import { isMobile } from 'react-device-detect';

import Translate from '../../components/common/translate';
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import ja from "date-fns/locale/ja";

var jaLocale = {
    ...ja,
    options: {
        weekStartsOn: 0, firstWeekContainsDate: 1
    }
}
registerLocale('ja', jaLocale);
const getTranslateValue = Utils.getTranslateValue;

const API = {
    GETBILLINGDETAILSINFO: window.domainDir + "api/Billing/GetBillingDetailsInfo",
    VALIDATEIRAI: window.domainDir + "api/Billing/ValidateIrai"
};

const URLPath = {
    IRC0101: "/Billing/Search",
    IRC0111_1: "/Billing/Delete/Confirmation",
    IHN0101: "/Product/Search"
}

const SESSION_KEYS = {
    IRAINO: 'bbmedical_iraino',
    SHOWPASSWORD: 'bbmedical_showpassword'
}

const IRC0111_Master = (props) => {
    let translate = useRef(null);
    let history = useHistory();

    const [currentPage, setPageNo] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [isFetching, setLoadingState] = useState(false);
    const [isFacilityLoaded, setFacilityLoaded] = useState(false);
    const [isFromRegisterBilling, setIsFromRegisterBilling] = useState(false);

    const [translateSuccess, setTranslateSuccess] = useState(false);

    const [deliveredItems, setDeliveredItems] = useState([]);
    const [facility, setFacility] = useState({
        IraiStatus: 0,
        PostalCode: "",
        Address: "",
        FacilityName: "",
        KanjiName: "",
        KanaName: "",
        DepartmentName: "",
        Phone: "",
        Fax: "",
        Email: "",
        DateShipped: "",
        InvoiceNumber: "",
        DeliveryCompany: "",
        HasShuka: false,
        HaisoUrl: ""
    });

    useEffect(() => {
        $("#loading").fadeIn();
        initFromSession().always(() => $("#loading").fadeOut());
        const stored = sessionStorage.getItem('bbmedical_billingcomplete') === "true";
        setIsFromRegisterBilling(stored)
        console.log(stored)
        sessionStorage.removeItem('bbmedical_billingcomplete');
    }, []);

    function initFromSession() {
        const rawNo = sessionStorage.getItem(SESSION_KEYS.IRAINO);
        const rawPw = sessionStorage.getItem(SESSION_KEYS.SHOWPASSWORD);

        // if missing, go back to IRC0101 screen
        if (!rawNo || !rawPw) {
            history.replace(URLPath.IRC0101);
            return $.Deferred().resolve(); 
        }

        // validate first before displaying details
        return ajax({
            url: API.VALIDATEIRAI,
            type: 'GET',
            data: { iraiNo: rawNo, password: rawPw },
            credentials: 'same-origin',
            dataType: "json"
        })
            .done(function (res) {
                let payload = null;
                if (res) {
                    if (res.Response !== undefined && res.Response !== null) {
                        payload = res.Response;
                    } else if (res.data !== undefined && res.data !== null) {
                        payload = res.data;
                    }
                }
                const isValid = payload && payload.IsValid === true;

                if (!isValid) {
                    history.replace(URLPath.IRC0101);
                } else {
                    fetchBillingDetails(Number(rawNo));
                }
            })
            // .always(function () {
            //     sessionStorage.removeItem(SESSION_KEYS.IRAINO);
            //     sessionStorage.removeItem(SESSION_KEYS.SHOWPASSWORD);
            // });
    }

    function fetchBillingDetails(iraiNo) {
        return ajax({
            url: API.GETBILLINGDETAILSINFO,
            type: 'GET',
            data: { iraiNo: iraiNo },
            credentials: 'same-origin',
            dataType: "json"
        })
            .done(function (res) {
                var payload = null;
                if (res) {
                    if (res.Response !== undefined && res.Response !== null) {
                        payload = res.Response;
                    } else if (res.data !== undefined && res.data !== null) {
                        payload = res.data;
                    }
                }
                if (!payload) return;

                var irai = payload.Irai || null;
                var details = payload.Details || [];
                var shuka = payload.Shuka || null;
                var haiso = payload.Haiso || null;

                // Header / facility
                setFacility({
                    IraiStatus: (irai && irai.IraiStatus) || 0,
                    PostalCode: (irai && irai.ZipNo) || "",
                    Address: [irai && irai.Todofuken, irai && irai.Address1, irai && irai.Address2, irai && irai.Address3].filter(Boolean).join(""),
                    FacilityName: (irai && irai.IraiFacilityName) || "",
                    KanjiName: (irai && irai.IraishaName) || "",
                    KanaName: (irai && irai.IraishaNameKana) || "",
                    DepartmentName: (irai && irai.IraiDepartmentName) || "",
                    Phone: (irai && irai.Tel) || "",
                    Fax: (irai && irai.Fax) || "",
                    Email: (irai && irai.Email) || "",
                    DateShipped: (shuka && shuka.ShukaDt) ? moment(shuka && shuka.ShukaDt).format("YYYY/MM/DD") : "",
                    InvoiceNumber: (shuka && shuka.HaisoDenNo) || "",
                    DeliveryCompany: (haiso && haiso.HaisoName) || "",
                    HasShuka: !!shuka,
                    HaisoUrl: (payload && payload.HaisoUrl) || "",
                });

                // Table rows
                var rows = (details || []).map(function (d, idx) {
                    return {
                        Id: idx + 1,
                        ImgSrc: d.ImgSrc || "/img/big%20bell/noimage.jpg",
                        CategoryName: d.CategoryName || "",
                        PromotionalItemName: d.HansokuName || "",
                        PromotionalItemCode: d.HansokuCode || "",
                        BillingQuantity: d.IraiQt || 0
                    };
                });
                setDeliveredItems(rows);
                setFacilityLoaded(true);
            })
            .fail(function () {
                setStatusMessage(CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
                setFacilityLoaded(true);
            })
    }

    function renderSearchPanel() {
        return (
            <div>
                {renderFacilityInfo()}
                {renderOrdererInfo()}
            </div>
        );
    }

    function handleRedirect(path) {
        if (typeof path === 'string' || path instanceof String) {
            history.push(path);
        }
    }

    function renderFacilityInfo() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.facilityinfo")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.postalcode")}
                    name="postalcode"
                    value={facility.PostalCode}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.address")}
                    name="address"
                    value={facility.Address}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.facilityname")}
                    name="facilityname"
                    value={facility.FacilityName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.phonenumber")}
                    name="phonenumber"
                    value={facility.Phone}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.fax")}
                    name="fax"
                    value={facility.Fax}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
            </div>
        );
    }

    function renderOrdererInfo() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.ordererinfo")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.kanjiname")}
                    name="kanjiname"
                    value={facility.KanjiName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.kananame")}
                    name="kananame"
                    value={facility.KanaName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.email")}
                    name="email"
                    value={facility.Email}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.departmentname")}
                    name="departmentname"
                    value={facility.DepartmentName}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
            </div>
        );
    }

    function renderDeliveredMaterialsTable() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.deliveredmaterials")}</legend>
                <IRC0111Table
                    data={deliveredItems}
                    pageNo={currentPage}
                    sizePerPage={sizePerPage}
                    isFetching={isFetching}
                    translate={translate}
                    setPageNo={setPageNo.bind(this)}
                    setSizePerPage={setSizePerPage.bind(this)}
                    getTranslateValue={getTranslateValue.bind(this)}
                />
            </div>
        );
    }

    function renderActionButtons() {
        return (
            <div className="row form-group">
                <div className="col-xs-4 text-left">
                    <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.irc0111.back")} onClick={handleRedirect.bind(this, URLPath.IRC0101)}  />
                </div>
                {!facility.HasShuka && (
                    <div className={isMobile ? "col-xs-8 text-right" : "col-xs-4 text-center"}>
                        <Button color="Success" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.irc0111.cancelbilling")}onClick={handleRedirect.bind(this, URLPath.IRC0111_1)}/>
                    </div>
                )}
                {!isMobile && <div className="col-xs-4" />}
            </div>
        );
    }

    function renderSteps() {
        const status = facility.IraiStatus; // 0, 1, 10, 11
        const hasShuka = facility.HasShuka;
        const hasHaisoDenNo = !!facility.InvoiceNumber;

        const baseCondition = hasShuka || status === 1;

        const isFirstBoxActive = isFacilityLoaded && !baseCondition;                                   
        const isSecondBoxActive = isFacilityLoaded && baseCondition && !hasHaisoDenNo; 
        const isThirdBoxActive = isFacilityLoaded && baseCondition && hasHaisoDenNo;                  

        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 12 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {/* First Box: Billing Reception */}
                    <button className="shipment-steps dashed" style={{ border: isFirstBoxActive ? "2px solid #c94b4b" : "", background: isFirstBoxActive ? "#f7e0e0" : "", color: isFirstBoxActive ? "#3a3a3a" : "", borderRadius: isFirstBoxActive ? 4 : "" }}>{getTranslateValue(translate.current, "views.irc0111.billingreception")}</button>
                    <img className="shipment-steps-arrow" src={window.baseUrl +  "/img/big%20bell/arrow_forward.png"} />
                    {/* Second Box: Shipping in Progress */}
                    <button className="shipment-steps dashed" style={{ border: isSecondBoxActive ? "2px solid #c94b4b" : "", background: isSecondBoxActive ? "#f7e0e0" : "", color: isSecondBoxActive ? "#3a3a3a" : "", borderRadius: isSecondBoxActive ? 4 : "" }}>{getTranslateValue(translate.current, "views.irc0111.shippinginprogress")}</button>
                    <img className="shipment-steps-arrow" src={window.baseUrl +  "/img/big%20bell/arrow_forward.png"} />
                </div>
                {/* Third Box: Shipped */}
                <div style={{ border: isThirdBoxActive ? "2px solid #c94b4b" : "1px solid #666", background: isThirdBoxActive ? "#f7e0e0" : "#eeeeee", padding: "12px 30px", height: 71, borderRadius: isThirdBoxActive ? 4 : 2, display: "flex", alignItems: "center", justifyContent: isThirdBoxActive ? "space-between" : "center", minWidth: isThirdBoxActive ? 450 : 150 }}>
                    <div style={{ fontWeight: isThirdBoxActive ? 700 : 'normal', fontSize: isThirdBoxActive ? 18 : 13, color: "#3a3a3a" }}>
                        {getTranslateValue(translate.current, "views.irc0111.shipped")}{isThirdBoxActive && facility.DateShipped ? ` (${facility.DateShipped})` : ""}
                    </div>
                    {isThirdBoxActive && ( 
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", fontSize: 13, color: "#333" }}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
                                <div style={{ width: 110, textAlign: "right", paddingRight: 8, color: "#666" }}>{getTranslateValue(translate.current, "views.irc0111.deliverycompany")}：</div>
                                <div style={{ minWidth: 0 }}>{facility.DeliveryCompany}</div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ width: 110, textAlign: "right", paddingRight: 8, color: "#666" }}>{getTranslateValue(translate.current, "views.irc0111.invoicenumber")}：</div>
                                <div>
                                    {facility.HaisoUrl
                                        ? (
                                            <a href={facility.HaisoUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a73e8", textDecoration: "underline" }}>
                                                {facility.InvoiceNumber}
                                            </a>
                                        ) : (
                                            <span>{facility.InvoiceNumber}</span>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    function renderStepsMobile() {
        const status = facility.IraiStatus; // 0, 1, 10, 11
        const hasShuka = facility.HasShuka;
        const hasHaisoDenNo = !!facility.InvoiceNumber;

        const baseCondition = hasShuka || status === 1;

        const isFirstBoxActive = isFacilityLoaded && !baseCondition;                                   
        const isSecondBoxActive = isFacilityLoaded && baseCondition && !hasHaisoDenNo; 
        const isThirdBoxActive = isFacilityLoaded && baseCondition && hasHaisoDenNo;                  

        if (isThirdBoxActive) {
            return (
            <div style={{  display: "flex", justifyContent: "center", width: "100%", marginBottom: 12, }}>
                <div style={{ border: "2px solid #c94b4b", background: "#f7e0e0", color: "#3a3a3a", borderRadius: 4, padding: "12px 15px", width: "100%", maxWidth: 450, boxSizing: "border-box",}}>
                    <div style={{ fontWeight: isThirdBoxActive ? 700 : 'normal', fontSize: isThirdBoxActive ? 18 : 13, color: "#3a3a3a", textAlign: isThirdBoxActive ? "left" : "center", marginBottom: isThirdBoxActive ? 10 : 0, }}>
                        {getTranslateValue(translate.current, "views.irc0111.shipped")}
                        {isThirdBoxActive && facility.DateShipped ? ` (${facility.DateShipped})` : ""}
                    </div>

                    {isThirdBoxActive && (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", fontSize: 13, color: "#333", width: "100%", }}>
                            <div style={{  display: "flex", alignItems: "flex-start", width: "100%", marginBottom: 6,flexWrap: "wrap",}}>
                                <div style={{ width: 110, minWidth: 110, textAlign: "right", paddingRight: 8, color: "#666", boxSizing: "border-box", }}> {getTranslateValue(translate.current, "views.irc0111.deliverycompany")}：</div>
                                <div style={{ minWidth: 0, flex: 1, overflowWrap: "break-word", wordBreak: "break-word", }}>{facility.DeliveryCompany}</div>
                            </div>
                            <div style={{ display: "flex", alignItems: "flex-start", width: "100%", flexWrap: "wrap", }}>
                                <div style={{ width: 110, minWidth: 110, textAlign: "right", paddingRight: 8, color: "#666", boxSizing: "border-box", }}>{getTranslateValue(translate.current, "views.irc0111.invoicenumber")}：</div>
                                <div style={{ minWidth: 0, flex: 1, overflowWrap: "break-word", wordBreak: "break-word",}} >
                                {facility.HaisoUrl
                                        ? (
                                            <a href={facility.HaisoUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a73e8", textDecoration: "underline" }}>
                                                {facility.InvoiceNumber}
                                            </a>
                                        ) : (
                                            <span>{facility.InvoiceNumber}</span>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div> 
            );
        }

        return (
            <div className="shipment-steps-mobile">
                <div className="shipment-steps-mobile-box">
                    <button className={`shipment-steps-mobile ${isFirstBoxActive ? "active" : ""}`}> {getTranslateValue(translate.current, "views.irc0111.billingreception")} </button>
                    <button className={`shipment-steps-mobile ${isSecondBoxActive ? "active" : ""}`}> {getTranslateValue(translate.current, "views.irc0111.shippinginprogress")}</button>
                    <button className={`shipment-steps-mobile ${isThirdBoxActive ? "active" : ""}`} > {getTranslateValue(translate.current, "views.irc0111.shipped")}</button>
                </div>
            </div>
        );
    }

    return (
        <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
            <ContentTitle active="#IRC0111" title={isFromRegisterBilling === true ? getTranslateValue(translate.current, "views.irc0111.billingrequestcompleted") : getTranslateValue(translate.current, "views.irc0111.confirmbillingdetails")} />
            {/* <div className="row" style={{ marginBottom: 12 }}>
                <div className="col-sm-4">
                    <div className="col-sm-4" >
                        <Button color="Default" className="flex-grow-0" label={getTranslateValue(translate.current, "views.irc0111.back")} onClick={handleRedirect.bind(this, URLPath.IRC0101)} />
                    </div>
                </div>
            </div> */}
            <div className="row form-group" style={{ marginTop: 12 }}>
                <div className="col-xs-4 text-left">
                    <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.irc0111.back")} onClick={handleRedirect.bind(this, URLPath.IRC0101)} />
                </div>
            </div>
            {isMobile ? renderStepsMobile() : renderSteps()}
            <div className="main-content">
                <div className="container-fluid" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    {renderSearchPanel()}
                    {renderDeliveredMaterialsTable()}
                    <div style={{ height: 25 }} />
                    {renderActionButtons()}
                </div>
            </div>
        </Translate>
    )
}

export default IRC0111_Master;


// WEBPACK FOOTER //
// ./view/IRC0111/irc0111.jsx